<template>
  <!-- <div class="over-mask" :style="{display:dialogVisible? 'block':'none'}"> -->
  <el-dialog
    title="计算器"
    :visible="dialogVisible"
    width="21%"
    custom-class="theme-dialog task-dialog"
    :before-close="closeCallBack"
    :append-to-body="true"
    :destroy-on-close="true"
  >
    <div class="content" style="margin-top: -24px">
      <account-calculator :title="title" :ratio="accountingRate" />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="normal-button" @click="closeCallBack" plain>取 消</el-button>
      <el-button class="normal-button" type="primary" @click="closeCallBack">确 定</el-button>
    </span>
  </el-dialog>

  <!-- </div> -->
</template>
<script>
import AccountCalculator from '@/components/base/AccountCalculator.vue'
export default {
  components: { AccountCalculator },
  props: {
    dialogVisible: {
      type: Boolean
    },
    handleClose: {
      type: Function
    }
  },
  data() {
    return {
      // dialogVisible:true,
      title: ''
    }
  },
  computed: {
    accountingRate(){
      return this.$store.getters.accountingRate || 0
    },
  },
  methods: {
    closeCallBack() {
      this.$emit('handleClose')
    }
  }
}
</script>
<style lang="scss">
.over-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  z-index: 9999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-dialog__footer {
    // border-top:1px solid rgba(0,0,0,0.5);
  }
  .el-dialog__wrapper {
    z-index: 10000 !important;
  }
}
</style>
<style lang="scss">
.task-dialog {
  // background: rgba(0,0,0,0.5);
  // z-index: 9999 !important;
  .el-dialog__body {
    padding: 0 !important;
    .content {
      .box-border.relative {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      }
      .border-theme-gray {
        border-color: transparent;
      }
    }
  }
}
</style>
